import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Badge } from "reactstrap";

export default function EnglishTranslation() {
  const { surahId } = useParams();
  const [translators, setTranslators] = useState([]);
  const [activeTranslator, setActiveTranslator] = useState(null);
  const [activeTranslatorData, setActiveTranslatorData] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/surah/translators`)
      .then((res) => {
        setTranslators(res.data);
        setActiveTranslator(res.data[0].id);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [surahId]);

  useEffect(() => {
    if (!activeTranslator) return;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/surah/translation?surahId=${surahId}&translatorId=${activeTranslator}`
      )
      .then((res) => {
        setActiveTranslatorData(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [activeTranslator,surahId]);

  return (
    <>
      <div>
        {translators.map((translator) => {
          return (
            <Badge
              key={translator.id}
              onClick={() => {
                setActiveTranslator(translator.id);
              }}
              {...(activeTranslator === translator.id
                ? { color: "primary" }
                : {})}
              style={{ marginLeft: 5, cursor: "pointer" }}
            >
              {translator.name}
            </Badge>
          );
        })}
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: activeTranslatorData?.text,
        }}
        className="mt-4 text-dark custom-desc"
      />
    </>
  );
}
